module.exports = __webpack_public_path__ + "images/emoji/blowfish.ed967e17361509a08f8b.png";